import { RadioGroupOptionType, SelectOptionType } from '@case-management/components';

import { FieldComponentTypeEnum } from './component-type.model';

export enum FieldSceneEnum {
  EditAllField = 1,
  Archive = 2,
}

export enum FieldsStatusEnum {
  ACTIVE = '1',
  INACTIVE = '0',
}

export enum FieldPermissionEnum {
  AGENT_ONLY = '001',
  READONLY_FOR_CONTACTS = '002',
  EDITABLE_FOR_CONTACTS = '003',
}

type ConditionKeysType = Record<
  'is_system' | 'is_case_bulk_update' | 'is_case_properties' | 'is_view_filters',
  boolean
>;
export type FieldOptionType = (SelectOptionType | RadioGroupOptionType) & ConditionKeysType & { group_ids: string[] };
export interface FieldWithOptionType extends ConditionKeysType {
  id: string;
  key: string;
  filter_type: FieldComponentTypeEnum;
  component_type: FieldComponentTypeEnum;
  label: string;
  agent_required_create_or_update: boolean;
  agent_required_submit: boolean;
  options: FieldOptionType[];
}

export interface FieldsType {
  id: string;
  key: string;
  label: string;
  data_type: string;
  agent_display_name: string;
  is_view_default: boolean;
  is_view_checked: boolean;
  is_view_show: boolean;
  is_system: boolean;
  is_view_filters: boolean;
  dict_list: any[];
  component_type: FieldComponentTypeEnum;
  status: FieldsStatusEnum;
}

export interface FieldValue {
  id?: string;
  parent_id?: string;
  value: string;
  contact_dict_value?: string;
  is_system?: boolean;
  [key: string]: any;
}

export class CustomFieldModel {
  agent_display_name = '';

  description = '';

  agent_required_create_or_update = false;

  agent_required_submit = false;

  agent_required_close = false;

  shown_contact = '';

  contact_display_name = '';

  shown_contact_description = '';

  contact_display = false;

  contact_edit = false;

  contact_required_submit = false;

  can_add_field_value = false;

  case_dict_lists: FieldValue[] = [];

  component_type = FieldComponentTypeEnum.Dropdown;

  dict_json = '[]';

  entity_id?: number;

  id?: string;

  is_system = false;

  is_field_hide_in_form = false;

  is_field_forbid_delete_in_from = false;

  show_field_values = false;

  status = '';

  is_show = false;

  key = '';

  create_by = '';

  create_by_name = '';

  create_at = '';

  update_at = '';

  permission = FieldPermissionEnum.AGENT_ONLY;

  max_permission = FieldPermissionEnum.EDITABLE_FOR_CONTACTS;

  scene?: FieldSceneEnum = FieldSceneEnum.EditAllField;
}

export type CustomFieldType = Partial<CustomFieldModel>;
